import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'src/@/components/ui/dialog';
import Iconify from 'src/components/Iconify';
import { useTranslation } from 'react-i18next';
import useAuth from 'src/hooks/useAuth';
import v2_actionCriarCanal from 'src/actions/v2/cliente/canais/v2_actionCriarCanal';
import ChannelCreationForm from './ChannelCreationForm';

const EMPTY_CHANNEL = {
    nome: '',
    platform: '',
    webhook_type: '',
};

export default function DialogNewChannel({
    open,
    onClose,
    onSubmit,
    initialPlatform = '',
}) {
    const { t } = useTranslation('settings');
    const { cliente } = useAuth();
    const [formKey, setFormKey] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState('');
    const [channelData, setChannelData] = useState(EMPTY_CHANNEL);

    useEffect(() => {
        if (!open) return;
        setChannelData({ ...EMPTY_CHANNEL, platform: initialPlatform || '' });
        setSubmitError('');
        setIsSubmitting(false);
        setFormKey((current) => current + 1);
    }, [open, initialPlatform]);

    function handleChange(event) {
        const { name, value } = event.target;

        setChannelData((prev) => ({
            ...prev,
            [name === 'channelName'
                ? 'nome'
                : name === 'channelType'
                  ? 'platform'
                  : name === 'webhookType'
                    ? 'webhook_type'
                    : name]: value,
        }));
    }

    async function handleCreateChannel(data) {
        setIsSubmitting(true);
        setSubmitError('');
        try {
            const requestData = {
                scope: {
                    nome: data.nome,
                    platform: data.platform,
                    webhook_type: data.webhook_type,
                },
            };
            const response = await v2_actionCriarCanal(cliente._id, requestData);
            onSubmit(response.data.data._id);
        } catch (error) {
            console.error('Erro ao criar canal:', error);
            setSubmitError(t('channels.creationForm.createError'));
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <Dialog open={open} onOpenChange={(nextOpen) => { if (!nextOpen) onClose(); }}>
            <DialogContent className="sm:max-w-3xl w-[95vw] max-h-[92vh] p-0 overflow-hidden flex flex-col gap-0 border-0 shadow-2xl">
                <DialogHeader className="px-6 py-5 border-b border-gray-100 text-left">
                    <div className="flex items-center gap-3 pr-8">
                        <div className="w-11 h-11 rounded-2xl bg-violet-50 text-[#7C3AED] flex items-center justify-center">
                            <Iconify icon="solar:add-circle-bold-duotone" width={25} className="text-[#7C3AED]" />
                        </div>
                        <div>
                            <DialogTitle className="text-lg font-bold text-gray-900">
                                {t('channels.creationForm.modalTitle')}
                            </DialogTitle>
                            <p className="text-sm text-gray-500 mt-1">
                                {t('channels.creationForm.modalSubtitle')}
                            </p>
                        </div>
                    </div>
                </DialogHeader>

                <div className="flex-1 overflow-hidden min-h-0">
                    {open && (
                        <ChannelCreationForm
                            key={formKey}
                            onSubmit={handleCreateChannel}
                            onChange={handleChange}
                            onCancel={onClose}
                            canal={channelData}
                            isSubmitting={isSubmitting}
                            submitError={submitError}
                        />
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}


